import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        tableContentWrapper: {
            padding: 0,
            borderRadius: 0,
            width: '100%',
            boxSizing: 'border-box',
            border: 'none',
        },
        tableContent: {
            boxShadow: 'none !important',
            maxHeight: 585,
        },
    }
})

export default useStyles
